import { Event, WebLink } from "../../../models";
import {
    IonCol,
    IonItem,
    IonLabel,
    IonList,
    IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import moment from "moment";
import Spinner from "../../Spinners/Spinner";

interface _Props {
    event: Event
}

const EventDisplayWeblinks: React.FC<_Props> = ({event}) => {
    const [formattedWebLinks, setFormattedWebLinks] = useState<WebLink[]>();
    const [isLoading, setIsLoading] = useState(false);

    async function formatWebLinks(webLinks: any[]) {
        setIsLoading(true);
        const sorted = webLinks.sort((a, b) => b.createdOn.localeCompare(a.lastcreatedOnUpdated));
        setFormattedWebLinks(sorted);
        setIsLoading(false);
    }

    useEffect(() => {
        if (event && event.webLinks) {
            formatWebLinks(event.webLinks);
        } else if (event && !event.webLinks) {
            setFormattedWebLinks([]);
        }
    }, [event]);

    return (
        <>
            {isLoading ?
                <IonRow className="ion-justify-content-center">
                    <IonCol className="ion-text-center">
                        <Spinner />
                    </IonCol>
                </IonRow>
                :
                <>
                    {formattedWebLinks && formattedWebLinks.length ?
                        <>
                            <IonRow>
                                <IonCol>
                                    <IonList className="bg-white">
                                        {formattedWebLinks.map((webLink, index) => (
                                            <IonItem key={index}>
                                                <IonLabel>
                                                    {webLink?.url ?
                                                        <IonRow>
                                                            <IonCol size="12">
                                                                {(webLink && webLink.title) ?
                                                                    <a href={webLink?.url} rel="noopener noreferrer"  target="_blank" >
                                                                        <h2 className="ion-text-wrap link">{webLink.title}</h2>
                                                                    </a>
                                                                    :
                                                                    <></>
                                                                } 
                                                            </IonCol>
                                                            <IonCol size="12">
                                                                <a href={webLink?.url} rel="noopener noreferrer"  target="_blank" >
                                                                    <p className="ion-text-wrap link">Full Link: {webLink && webLink.url}</p>
                                                                </a>
                                                            </IonCol>
                                                            <IonCol size="12">
                                                                <p className="description ion-text-wrap">(Last Updated: {webLink?.createdOn ? moment(webLink.createdOn).format("MM/DD/YYYY hh:mm a") : ""})</p>
                                                            </IonCol>
                                                        </IonRow>
                                                        :
                                                        <IonRow>
                                                            <p>Error - web link URL is not available.</p>
                                                        </IonRow>
                                                    }
                                                </IonLabel>
                                            </IonItem>
                                        ))}
                                    </IonList>
                                </IonCol>
                            </IonRow>
                        </>
                        :
                        <>
                            <IonRow>
                                <IonCol>
                                    <IonItem>
                                        <IonLabel><h3>No website links listed.</h3></IonLabel>
                                    </IonItem>
                                </IonCol>
                            </IonRow>
                        </>
                    }
                </>
            }
        </>
    );
};

export default EventDisplayWeblinks;